import firebase from 'firebase/app';
import { getBrowserData } from '@/services/browser';
import { isSafeConnection } from '@/services/connection';
import { getAll } from '@/services/features';
import { isCurrentAccountTest, getSignUpProvider } from '@/services/user';
import { getExtensionDetails } from '@/services/extension';
import { version } from '../../package.json';

function getUserDetails() {
  const user = firebase.auth().currentUser;

  if (!user) {
    return {};
  }

  return {
    uid: user.uid,
    hasEmail: !!user.email,
    provider: getSignUpProvider(user),
    testAccount: isCurrentAccountTest(),
  };
}

function getDeviceDetails() {
  return {
    windowWidth: window.screen?.width,
    windowHeight: window.screen?.height,
    colorDepth: window.screen?.colorDepth,
  };
}

// eslint-disable-next-line import/prefer-default-export
export async function getDump() {
  return {
    website: { version },
    browser: getBrowserData(),
    extension: await getExtensionDetails(),
    user: getUserDetails(),
    connection: { safe: await isSafeConnection() },
    features: await getAll(),
    device: getDeviceDetails(),
  };
}
